export default "__VITE_ASSET__B02vI$ar__"